import React from "react";
import { useAuth } from "react-oidc-context";
import { LockIcon } from "../../icons";
import "./AccessDeniedPage.scss";

function AccessDeniedPage() {
  const auth = useAuth();

  const email = auth.user?.profile?.email || auth.user?.profile?.sub || "your account";

  const handleSignOut = async () => {
    try {
      await auth.removeUser();
      await auth.signoutRedirect({
        post_logout_redirect_uri: window.location.origin + "/login",
      });
    } catch {
      // Fallback: hard redirect to login
      window.location.replace(window.location.origin + "/login");
    }
  };

  return (
    <div className="ad-shell">
      {/* ── Minimal branded header ── */}
      <header className="ad-header">
        <img src="/Topcon_logo.png" alt="Topcon" className="ad-header__logo" />
        <div className="ad-header__title-group">
          <span className="ad-header__app-name">AV Sync</span>
          <span className="ad-header__app-subtitle">
            Video&nbsp;·&nbsp;Subtitle&nbsp;·&nbsp;Synchronisation
          </span>
        </div>
      </header>

      {/* ── Access denied card ── */}
      <main className="ad-main" role="main">
        <div className="ad-card" role="alert" aria-live="assertive">
          <LockIcon className="ad-icon" />

          <h1 className="ad-card__heading">Access Restricted</h1>

          <p className="ad-card__message">
            Your account currently does not have access to AV Sync.
          </p>

          <p className="ad-card__sub">
            Please contact the AV Sync Administrator to request access.
          </p>

          {/* Signed-in account indicator */}
          <div className="ad-card__account">
            <span className="ad-card__account-label">Signed in as</span>
            <span className="ad-card__account-email">{email}</span>
          </div>

          <button className="ad-card__signout-btn" onClick={handleSignOut} type="button">
            Sign Out
          </button>
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="ad-footer">
        <span>© {new Date().getFullYear()} Topcon. All rights reserved.</span>
      </footer>
    </div>
  );
}

export default AccessDeniedPage;
